// extracted by mini-css-extract-plugin
export default {"app":"Login_app__Ip61x","image":"Login_image__2dGqr","head":"Login_head__TPrO2","bang":"Login_bang__rJgSp","my_btn":"Login_my_btn__OOl8f"};